import { ArticleWithRelations, RequestWithRelations } from '@/models/request';
import { UserFromGetSession } from '@/models/user';
import { WorkflowPublic } from '@/models/workflow';
import {
  RequestArticleContextData,
  RequestContextData,
} from '@/routes/Requests/contexts/interfaces';

export const computeAcceptDispatchProposalContext = ({
  article,
  view,
  requestView,
}: {
  request: RequestWithRelations;
  requestView: RequestContextData['view'];
  workflow?: WorkflowPublic;
  article: ArticleWithRelations;
  view: RequestArticleContextData['view'];
  currentSession: UserFromGetSession;
}) => {
  /**
   * SERVICES
   */
  view.services.actions.fields.description.editable = true;
  view.services.actions.fields.brandResponsibility.editable = true;
  view.services.actions.fields.organizationPrice.editable = requestView.organizationPrice.editable;
  view.services.actions.fields.organizationPrice.required =
    article.step?.step === 'service-choice' && !!article.step.config.requireOrganizationPrice;
  view.services.actions.fields.spareParts.organizationPrice.editable =
    requestView.organizationPrice.editable;
  view.services.actions.fields.spareParts.organizationPrice.required =
    article.step?.step === 'service-choice' && !!article.step.config.requireOrganizationPrice;

  view.services.dispatch.editable = false;

  /**
   * DEFECTS
   */
  view.defects.fields.brandResponsibility.toggle.editable = true;
};
